<div class="login-content">

   <div class="login-flex">

    <div class="side1">
        <!-- having amazing backgound -->
        <div class="content">
            <h2>
                Loga-te e decruba mais sobre o Kulonga
            </h2>
            <p>
                Lorem ipsum dolor sit amet consectetur adipisicing elit.
            </p>
            <p>Quod dolore praesentium suscipit animi maxime 
                </p>
                <p>deserunt corporis laudantium qui itaque!Ex repellat.</p>
        </div>
      
        <div class="gradient">
           
        </div>
    </div>
    <div class="side2">
<div class="headline">
    <h1>Cadastrar-se</h1>
    <img src="../../../assets/svg/times-close.svg" 
    [routerLink]="['']" width="80"
    alt="go back to home" class="leave">
      
</div>
    
        <form>
            <div>
                <label for="">Nome completo</label>
                <input type="text" placeholder name="">
            </div>

            <div>
                <label for="">Intituto/Universidade</label>
                <input type="text" name="" placeholder="ISPT">
            </div>

            <div>
                <label for="">Emial</label>
                <input type="text" name="" placeholder="exemplo@sever.com">
            </div>

            <div>
                <label for="">Telefone</label>
                <input type="text" name="" placeholder="exemplo@sever.com">
            </div>

            <div>
                <label for="">Codigo de estudante/BI</label>
                <input type="text" name="" placeholder="exemplo@sever.com">
            </div>

            <div class="account">
               <button>Cadastrar</button>
               <p>Ja tenho uma conta</p>
            </div>
        </form>
    </div>

</div>
</div>


